import React, { useRef, forwardRef } from "react";
import BaseButton from "./BaseButton";

interface FileLoadButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    accept?: string;
    children: React.ReactElement;
    ariaLabel: string;
    toolTipText?: string;
    onLoaded: (file: File) => void;
}

export const FileLoadButton = forwardRef<HTMLButtonElement, FileLoadButtonProps>(
    (
        {
            accept = "video/mp4",
            children,
            ariaLabel,
            toolTipText,
            onLoaded,
            ...rest
        }, ref
    ) => {

        const inputRef = useRef<HTMLInputElement | null>(null);

        const handleClick = () => {
            inputRef.current?.click();
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const file = e.target.files?.[0];
            if (file) {
                onLoaded(file);
                // optional: clear value so selecting same file twice still fires change
                e.target.value = "";
            }
        };

        return (
            <div className='file-load-button-container'>
                <BaseButton
                    ref={ref}
                    ariaLabel={ariaLabel}
                    tooltipText={toolTipText}
                    onClick={handleClick}
                    {...rest} >
                    {children}
                </BaseButton>

                <input
                    ref={inputRef}
                    type="file"
                    accept={accept}
                    style={{ display: "none" }}
                    onChange={handleChange}
                />
            </div>
        );
    }
)
